import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Green' },
    { value: 2, label: 'Yellow' },
    { value: 3, label: 'Orange' },
    { value: 4, label: 'Red' },
  ],
});
